import { environment } from "src/environments/environment";

export var global = {
  url: environment.API_URL,
};
